<template>
    <div class="large-text-editor" :class="{ 'wm-toastui-dark': isDark }">
        <div class="text-h6">{{ label }}</div>
        <editor
            ref="toastEditor"
            initial-edit-type="wysiwyg"
            preview-style="tab"
            :initial-value="value || ''"
            :height="editorHeight"
            :options="{ minHeight: '200px', language: 'en-GB' }"
            @change="handleChange"
        />
    </div>
</template>
<script>
import 'codemirror/lib/codemirror.css'
import '@toast-ui/editor/dist/toastui-editor.css'
import '@/assets/toastui-editor-dark.css'
import { Editor } from '@toast-ui/vue-editor'

export default {
    components: { Editor },
    computed: {
        isDark() {
            return this.$vuetify.theme.dark
        },
    },
    props: {
        value: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        editorHeight: {
            type: String,
            default: '500px',
        },
    },
    mounted() {
        // Suppress the spurious change event Toast UI fires during initialization
        // (content normalization causes markdown !== value, triggering a false dirty).
        this._editorReady = false
        setTimeout(() => { this._editorReady = true }, 0)

        // Toast UI v2 doesn't populate CodeMirror on mode switch from WYSIWYG.
        // Force-sync content then refresh so CodeMirror activates its scrollbar
        // and correctly computes cursor/selection positions.
        this._onChangeMode = mode => {
            if (mode === 'markdown') {
                this.$nextTick(() => {
                    const md = this.$refs.toastEditor.invoke('getMarkdown')
                    this.$refs.toastEditor.invoke('setMarkdown', md)
                    this.$refs.toastEditor.invoke('getCodeMirror').refresh()
                })
            }
        }
        this.$refs.toastEditor.invoke('on', 'changeMode', this._onChangeMode)
    },
    beforeDestroy() {
        this.$refs.toastEditor.invoke('off', 'changeMode', this._onChangeMode)
    },
    watch: {
        value(newValue) {
            if (!this.$refs.toastEditor) return
            const current = this.$refs.toastEditor.invoke('getMarkdown')
            if (newValue !== current) {
                this.$refs.toastEditor.invoke('setMarkdown', newValue || '')
            }
        },
    },
    methods: {
        handleChange() {
            if (!this._editorReady) return
            const markdown = this.$refs.toastEditor.invoke('getMarkdown')
            if (markdown !== this.value) {
                this.$emit('input', markdown)
            }
        },
    },
}
</script>
